import { createI18n } from "vue-i18n"
import en from "./locales/en.json"
import zh from "./locales/zh.json"

function getDefaultLocale() {
  const supportedLocales = ['zh', 'en']
  // 优先从 localStorage 读取用户之前的选择
  const stored = localStorage.getItem('locale')
  if (stored && supportedLocales.includes(stored)) return stored
  // 取浏览器系统语言
  const browserLang = navigator.language || navigator.userLanguage || ''
  const lang = browserLang.toLowerCase().split('-')[0]
  if (supportedLocales.includes(lang)) return lang
  // 默认英文
  return 'en'
}

const i18n = createI18n({
  legacy: false,
  fallbackLocale: 'en',
  locale: getDefaultLocale(),
  messages: {
    zh,
    en
  }
})

export default i18n
